// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.25 1.75H5.25C6.08 1.75 6.75 2.42 6.75 3.25V5.25C6.75 6.08 6.08 6.75 5.25 6.75H3.25C2.42 6.75 1.75 6.08 1.75 5.25V3.25C1.75 2.42 2.42 1.75 3.25 1.75Z',
  'M10.75 9.25H12.75C13.58 9.25 14.25 9.92 14.25 10.75V12.75C14.25 13.58 13.58 14.25 12.75 14.25H10.75C9.92 14.25 9.25 13.58 9.25 12.75V10.75C9.25 9.92 9.92 9.25 10.75 9.25Z',
  'M4.25 6.75V10.25C4.25 11.08 4.92 11.75 5.75 11.75H9.25',
];
